// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2RBNG","pro_comment":"index_pro_comment_1kPRQ"};